// extracted by mini-css-extract-plugin
export default {"layout-admin":"AdminLayout_layout-admin__-U1OQ","content":"AdminLayout_content__L6ScH"};